import { useEffect, useRef } from 'react'

export default function VideoPlayer({
  src,
  onPercentageWatchedMilestone,
}: {
  src: string
  onPercentageWatchedMilestone?(milestone: number, video: HTMLVideoElement): void
}) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const milestonesRef = useRef<Set<number>>(new Set())

  useEffect(() => {
    const video = videoRef.current
    if (!video || !onPercentageWatchedMilestone) return

    const handleTimeUpdate = () => {
      if (!video.duration) return
      ;[0, 25, 50, 75, 100].forEach((milestone) => {
        if (
          Math.round((video.currentTime / video.duration) * 100) >= milestone &&
          !milestonesRef.current.has(milestone)
        ) {
          onPercentageWatchedMilestone(milestone, video)
          milestonesRef.current.add(milestone)
        }
      })
    }

    video.addEventListener('timeupdate', handleTimeUpdate)
    return () => video.removeEventListener('timeupdate', handleTimeUpdate)
  }, [])

  return <video ref={videoRef} controls src={src} style={{ maxWidth: '100%' }} />
}
